<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import Modal from "../../../../components/modals/modal-form.vue";
import api from '../../../../helpers/apirest/api';

import {
    sourceDriverTypeComputed
} from "@/state/helpers";

const initialState = () => {
    return {
        submitted: false,
        source_driver: {

            source_driver_type_id: '',
            name: null,
            host: null,
            username: null,
            password: null,
            port: 21,
            key: null,
            secret: null,
            region: null,
            bucket: null,
            refresh_token: null,
        }
    };
}

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        id: Number
    },
    data() {
        return initialState();
    },
    components: {
        Modal
    },
    computed: {
        ...sourceDriverTypeComputed,
        withHost(){
            const allowDrivers = ['ftp'];
            return this.forSourceDriverType(allowDrivers);            
        },
        withUsername(){
            const allowDrivers = ['ftp'];
            return this.forSourceDriverType(allowDrivers);            
        },
        withPassword(){
            const allowDrivers = ['ftp'];
            return this.forSourceDriverType(allowDrivers);            
        },
        withPort(){
            const allowDrivers = ['ftp'];
            return this.forSourceDriverType(allowDrivers);            
        },
        withKey(){
            const allowDrivers = ['s3', 'google_drive', 'gmail'];
            return this.forSourceDriverType(allowDrivers);            
        },
        withSecret(){
            const allowDrivers = ['s3', 'google_drive', 'gmail'];
            return this.forSourceDriverType(allowDrivers);            
        },
        withRegion(){
            const allowDrivers = ['s3'];
            return this.forSourceDriverType(allowDrivers);            
        },
        withBucket(){
            const allowDrivers = ['s3'];
            return this.forSourceDriverType(allowDrivers);            
        },
        withRefreshToken(){
            const allowDrivers = ['google_drive', 'gmail'];
            return this.forSourceDriverType(allowDrivers);            
        },
    },
    validations: {
        source_driver: {

            source_driver_type_id: { required },
            name: { required },
            host: { 
                required: requiredIf(function() { 
                    return this.withHost 
                }),
             },
            username: { 
                required: requiredIf(function() { 
                    return this.withUsername 
                }),
            },
            password: {
                required: requiredIf(function() { 
                    return this.withPassword 
                }),
            },
            port: {
                required: requiredIf(function() { 
                    return this.withPort 
                }),
            },
            key: {
                required: requiredIf(function() { 
                    return this.withKey
                }),
            },
            secret: {
                required: requiredIf(function() { 
                    return this.withSecret
                }),
            },
            region: {
                required: requiredIf(function() { 
                    return this.withRegion
                }),
            },
            bucket: {
                required: requiredIf(function() { 
                    return this.withBucket
                }),
            },
            refresh_token: {
                required: requiredIf(function() { 
                    return this.withRefreshToken
                }),
            },
        }
    },
    methods: {
        forSourceDriverType(allowDrivers){
            if(this.sourceDriverTypes && this.source_driver?.source_driver_type_id){
                const selectedDriverType = this.sourceDriverTypes.find(item => item.id === this.source_driver?.source_driver_type_id)
                if(selectedDriverType && allowDrivers.includes(selectedDriverType?.slug)){
                    return true;
                }
            }
            return false;
        },
        async shown() {

            this.$store.dispatch("sourceDriverType/loadList");

            if (this.id) {
                const response = await api.get({
                    url: `source-drivers/${this.id}`
                });
                this.source_driver = response?.data?.data;
            }
        },
        async confirm() {

            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            const data = this.source_driver;

            await api.save({
                url: 'source-drivers',
                id: this.source_driver?.id,
                data: data 
            });

            this.$bvModal.hide(this.modalId);
            this.$emit("onSuccess");
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        resetModal() {
            Object.assign(this.$data, initialState());
        }
    }
};
</script>

<template>
    <Modal :title="'Custom title'" :id="modalId" @confirm="confirm" @cancel="cancel" @shown="shown" @hidden="resetModal">
        <div class="form-group">
            <label for="source_driver_type_id">Source Driver Type</label>
            <select v-model="source_driver.source_driver_type_id" class="form-control"
                :class="{ 'is-invalid': $v.source_driver.source_driver_type_id.$error && submitted }">
                <option value="">Select</option>
                <option v-for="option in sourceDriverTypes" v-bind:value="option.id" :key="option.id">
                    {{ option.name }}
                </option>
            </select>
            <div v-if="!$v.source_driver.source_driver_type_id.required && submitted" class="invalid-feedback">Source Driver Type is
                required</div>
        </div>
        <div class="form-group">
            <label for="name">Name</label>
            <input id="name" v-model="source_driver.name" type="text" class="form-control" placeholder="Enter name"
                :class="{ 'is-invalid': $v.source_driver.name.$error && submitted }" />
            <div v-if="!$v.source_driver.name.required && submitted" class="invalid-feedback">Name is required</div>
        </div>
        <div class="form-group" v-if="withHost">
            <label for="host">Host</label>
            <input id="host" v-model="source_driver.host" type="text" class="form-control" placeholder="Enter host"
                :class="{ 'is-invalid': $v.source_driver.host.$error && submitted }" />
            <div v-if="!$v.source_driver.host.required && submitted" class="invalid-feedback">Host is required</div>
        </div>
        <div class="form-group" v-if="withUsername">
            <label for="username">Username</label>
            <input id="username" v-model="source_driver.username" type="text" class="form-control" placeholder="Enter username"
                :class="{ 'is-invalid': $v.source_driver.username.$error && submitted }" />
            <div v-if="!$v.source_driver.username.required && submitted" class="invalid-feedback">Username is required</div>
        </div>
        <div class="form-group" v-if="withPassword">
            <label for="password">Password</label>
            <input id="password" v-model="source_driver.password" type="password" class="form-control" placeholder="Enter password"
                :class="{ 'is-invalid': $v.source_driver.password.$error && submitted }" />
            <div v-if="!$v.source_driver.password.required && submitted" class="invalid-feedback">Password is required</div>
        </div>
        <div class="form-group" v-if="withPort">
            <label for="port">Port</label>
            <input id="port" v-model="source_driver.port" type="port" class="form-control" placeholder="Enter port"
                :class="{ 'is-invalid': $v.source_driver.port.$error && submitted }" />
            <div v-if="!$v.source_driver.port.required && submitted" class="invalid-feedback">Port is required</div>
        </div>
        <div class="form-group" v-if="withKey">
            <label for="key">Key</label>
            <input id="key" v-model="source_driver.key" type="key" class="form-control" placeholder="Enter key"
                :class="{ 'is-invalid': $v.source_driver.key.$error && submitted }" />
            <div v-if="!$v.source_driver.key.required && submitted" class="invalid-feedback">Key is required</div>
        </div>
        <div class="form-group" v-if="withSecret">
            <label for="secret">Secret</label>
            <input id="secret" v-model="source_driver.secret" type="secret" class="form-control" placeholder="Enter secret"
                :class="{ 'is-invalid': $v.source_driver.secret.$error && submitted }" />
            <div v-if="!$v.source_driver.secret.required && submitted" class="invalid-feedback">Secret is required</div>
        </div>
        <div class="form-group" v-if="withRegion">
            <label for="region">Region</label>
            <input id="region" v-model="source_driver.region" type="region" class="form-control" placeholder="Enter region"
                :class="{ 'is-invalid': $v.source_driver.region.$error && submitted }" />
            <div v-if="!$v.source_driver.region.required && submitted" class="invalid-feedback">Region is required</div>
        </div>
        <div class="form-group" v-if="withBucket">
            <label for="bucket">Bucket</label>
            <input id="bucket" v-model="source_driver.bucket" type="bucket" class="form-control" placeholder="Enter bucket"
                :class="{ 'is-invalid': $v.source_driver.bucket.$error && submitted }" />
            <div v-if="!$v.source_driver.bucket.required && submitted" class="invalid-feedback">Bucket is required</div>
        </div>
        <div class="form-group" v-if="withRefreshToken">
            <label for="refresh_token">RefreshToken</label>
            <input id="refresh_token" v-model="source_driver.refresh_token" type="refresh_token" class="form-control" placeholder="Enter refresh_token"
                :class="{ 'is-invalid': $v.source_driver.refresh_token.$error && submitted }" />
            <div v-if="!$v.source_driver.refresh_token.required && submitted" class="invalid-feedback">Refresh Token is required</div>
        </div>
    </Modal>
</template>